import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {

  constructor() {
    // To do something
   }
}

export enum endpoints {
  // endpoints strapi
  cotizador = '/ce/auto/cotizacion',
  secciones = '/cms-secciones',
  menu = '/cms-menus',
  footer = '/cms-footers',
  seguros = '/cms-seguros',
  header = '/cms-headers',
}

